import { Controller } from "@hotwired/stimulus"

// Preselects the device's time zone for a new choir, when the list offers it.
export default class extends Controller {
  connect() {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (zone && [...this.element.options].some((option) => option.value === zone)) this.element.value = zone
  }
}
